import React from "react"
import { compose, withProps, branch } from "recompact"
import groupEvents from "src/hocs/groupEvents"
import groupPlanEvents from "src/hocs/groupPlanEvents"
import allEventTypes from "src/hocs/allEventTypes"
import GroupCard from "./GroupCard"

export default compose(
  withProps(props => ({ data: props.data })),
  branch(({ planId }) => !!planId, groupPlanEvents(), groupEvents()),
  allEventTypes(),
)(props => (
  <div>
    <GroupCard {...props} />
  </div>
))
